import React from "react"
import { Navigate } from "react-router-dom"
import PageContainer from "src/components/page/PageContainer"
import TabbedPageContainer from "src/components/page/TabbedPageContainer"
import { CompanyInfoTab } from "./CompanyInfoTab"
import { CompanyMembersTab } from "./CompanyMembersTab"
import { GatedCommunitiesTab } from "./GatedCommunitiesTab"
import { useResponsive } from "src/utils/useResponsive"

const CompanyPage = () => {
  const { isMobile } = useResponsive()
  if (isMobile) {
    return <Navigate to="" replace />
  }
  return (
    <PageContainer>
      <TabbedPageContainer
        defaultTabId="company-info"
        tabs={[
          {
            id: "company-info",
            label: "Company Information",
            content: <CompanyInfoTab />
          },
          {
            id: "company-members",
            label: "Team",
            content: <CompanyMembersTab />
          },
          {
            id: "gated-communities",
            label: "Knowledge Bases",
            content: <GatedCommunitiesTab />
          }
        ]}
      />
    </PageContainer>
  )
}

export default CompanyPage
